import { guides } from '@/mocks/motionComics';

export default function Guides() {
  const [featured, ...rest] = guides;
  return (
    <section id="guides" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-xs font-medium tracking-widest text-primary-400">READ &amp; LEARN</span>
            <h2 className="mt-3 font-heading text-2xl text-foreground-50 md:text-4xl">追更指南 · 看懂动态漫画</h2>
            <p className="mt-3 max-w-xl text-sm leading-7 text-foreground-300">
              从新手入门到行业观察，用几篇文章陪你更懂韩国动态漫画，追得明白、看得过瘾。
            </p>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 lg:grid-cols-2 md:gap-5">
          <a
            href="#guides"
            className="card-lift group relative flex min-h-[260px] overflow-hidden rounded-lg border border-background-300/50 md:min-h-[320px]"
          >
            <img
              src={featured.cover}
              alt={featured.title}
              title={featured.title}
              className="absolute inset-0 h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent"></div>
            <div className="relative z-10 mt-auto p-5 md:p-6">
              <span className="rounded bg-primary-500 px-2 py-0.5 text-[11px] font-semibold text-background-950">{featured.tag}</span>
              <h3 className="mt-3 font-heading text-lg leading-snug text-foreground-50 md:text-2xl">{featured.title}</h3>
              <p className="mt-2 text-xs leading-6 text-foreground-200 md:text-sm md:leading-7">{featured.excerpt}</p>
              <p className="mt-3 text-xs text-foreground-300">{featured.date}</p>
            </div>
          </a>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 md:gap-5 lg:grid-cols-1">
            {rest.map((g) => (
              <a
                key={g.title}
                href="#guides"
                className="card-lift flex gap-4 rounded-lg border border-background-300/50 bg-background-50 p-3 md:p-4"
              >
                <div className="h-20 w-28 shrink-0 overflow-hidden rounded-md sm:h-full sm:w-32 sm:self-stretch">
                  <img src={g.cover} alt={g.title} title={g.title} className="h-full w-full object-cover object-center" />
                </div>
                <div className="min-w-0">
                  <span className="rounded bg-secondary-100 px-1.5 py-0.5 text-[10px] text-secondary-900">{g.tag}</span>
                  <h3 className="mt-2 line-clamp-2 text-sm font-semibold leading-snug text-foreground-50 md:text-[15px]">{g.title}</h3>
                  <p className="mt-1.5 text-xs text-foreground-400">{g.date}</p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}